<template>
    <div class="page-wrapper flex margin-left-sm">
        <div class="flex flex-direction bg-white radius padding-sm w-100">
            <div class="content flex flex-direction">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="ruleForm margin-top-xs" v-loading="loading">
                    <el-form-item ref="phone" label="联系电话" prop="phone" class="input-container">
                        <el-input v-model="ruleForm.phone" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item ref="content" label="反馈内容" prop="content" class="input-container">
                        <el-input v-model="ruleForm.content" placeholder="请输入"
                                  type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" resize="none"></el-input>
                    </el-form-item>
                </el-form>
                <el-button class="btn max btn-gradual-orange round margin-tb-sm self-center" type="warning"
                           @click="submitForm('ruleForm')" :loading="submit_loading">
                    提交反馈
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>

import rules from "@/utils/rules";
import {feedback} from "@/api";
import {TOAST, toast} from "@/utils/utils";

export default {
    name: "feedback",
    data() {
        return {
            ruleForm: {
                phone: '',//
                content: '',//
            },
            rules: {
                phone: [
                    {required: true, message: '请输入联系电话', trigger: 'blur'},
                    rules.phone
                ],
                content: [
                    {required: true, message: '请输入反馈内容', trigger: 'blur'},
                ]
            },
            loading: false,
            submit_loading: false,
        }
    },
    created() {
        this.$emit('setIndex', [9,0], '意见反馈', false)
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    mounted() {
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitInfo()
                }
            });
        },
        async submitInfo() {
            this.submit_loading = true
            let _data = await feedback(
                this.ruleForm.phone,
                this.ruleForm.content,
            )
            this.submit_loading = false
            if (_data.status === 200) {
                toast('提交成功')
                this.$refs.ruleForm.resetFields()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
    },
    filters: {

    }

}
</script>

<style lang="scss" scoped>
.content{
    width: 50%;
}
</style>
